import { Box, Flex, Heading, Img, Text, useMediaQuery } from "@chakra-ui/react"
import React from "react"
import { useNavigate } from "react-router"
import madeInAus from "../../assets/images/madeInAus.png"
import { Paths, mobileBreakpoint } from "../../common/commonConstants"
import { chakraTheme } from "../../theme/chakraTheme"

export const ContactUs = (): JSX.Element => {
  const navigate = useNavigate()
  const button2Bold = chakraTheme?.components?.Button?.variants?.Button2Bold
  const [isDesktop] = useMediaQuery(`(min-width: ${mobileBreakpoint}px)`)

  const handleAboutUsClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault()
    navigate(Paths.CONTACTUS)
    // Use setTimeout to ensure the page has navigated before scrolling
    setTimeout(() => {
      const element = document.getElementById("contacUsTop")
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    }, 100)
  }

  return (
    <Box w="100%">
      <Flex mt={["0px", 0, "8px"]} align="center" flexDir={["column-reverse", "column-reverse", "row"]}>
        <Heading variant="Heading5" mt={["18px", "22px", "0"]}>
          Contact Us
        </Heading>
        <Img ml={[0, 0, "22px"]} mt={["2px", "2px", 1]} width={["48px", "48px", "60px"]} src={madeInAus} alt="Made in Australia" />
      </Flex>
      <Box
        maxW="270px"
        display={["flex", "flex", "flex", "static"]}
        justifyContent={["center", "center", "center", "flex-start"]}
        textAlign={["center", "center", "center", "left"]}
      >
        <Box position={"relative"} top={["0", 0, 0, "-3px"]} mt={["10px", "10px", "10px", "0px"]}>
          <Text mt={["8px", "0px", "0px"]} variant={["RCaption", "RCaption", "Body1Small"]}>
            Call us on
          </Text>
          <Text mt={["4px", "6px", "6px"]} variant={["RCaptionBold", "RCaptionBold", "Body1Small"]} fontWeight="700">
            <a href="tel:1300 76 46 26" style={{ ...(isDesktop && { fontWeight: "700", fontSize: "14px", lineHeight: "17px" }), ...button2Bold }}>
              1300 76 46 26
            </a>
            <Box as="span" mx={["6px", "6px", "8px"]} style={{ fontWeight: "normal" }}>
              &nbsp;or&nbsp;
            </Box>
            <a href="tel:+61 7 3390 5420" style={{ ...(isDesktop && { fontWeight: "700", fontSize: "14px", lineHeight: "17px" }), ...button2Bold }}>
              +61 7 3390 5420
            </a>
          </Text>
          <Text mt={["4px", "6px", "14px"]} variant={["RCaptionBold", "RCaptionBold", "Body1Small"]} fontWeight="700">
            <a
              href="mailto:support@snapcollars.com.au"
              style={{ ...(isDesktop && { fontWeight: "700", fontSize: "14px", lineHeight: "17px" }), ...button2Bold }}
            >
              Email us
            </a>
          </Text>
          <Text mt={["4px", "6px", "8px"]} variant={["RCaptionBold", "RCaptionBold", "Body1Small"]} fontWeight="700">
            <a
              href={`${Paths.CONTACTUS}#contacUsTop`}
              onClick={handleAboutUsClick}
              style={{
                ...(isDesktop && { fontWeight: "700", fontSize: "14px", lineHeight: "17px" }),
                ...button2Bold,
                textDecoration: "none"
              }}
            >
              About us
            </a>
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
